export default __webpack_public_path__ + "static/devops_a1_cloud_marcantoine_a-3ecf3ac58df883a01b202a5755f9dd78.jpg";